/* maligo® Farbhauch für die Hauptknöpfe (03.11.2026, Maui): ruhiger Rainbow-Schein unter schwarzen Hauptknöpfen,
   kein Rand, keine Bewegung (gleich wie „In den Warenkorb“ im Sample-Set, snippets/maligo-sample-kauf.liquid).
   Hauptknöpfe: „In den Warenkorb“ im Konfigurator, „Zur Kasse“ im Warenkorb, alle „Jetzt gestalten“-Knöpfe
   (Knopf-Links zum Konfigurator, nicht die umrandeten, keine Bild-Kacheln). Der Schein braucht einen Rahmen um den Knopf (span.mg-glow),
   sonst verschwindet er hinter Hintergründen; das Skript legt ihn an, auch wenn Warenkorb/Konfigurator neu zeichnen. */
(() => {
  const TARGETS = [
    '.mk__summary .mk__atc',
    '.cart__checkout-button',
    'a[href*="konfigurator=1"][class*="btn"]:not([class*="ghost"]):not([tabindex="-1"])'
  ].join(',');
  // weiße Hauptknöpfe auf dunklem Grund (Startseite „Jetzt deine Marke gestalten“) bekommen den Hauch auch
  const LIGHT_OK = '.m2-btn--w';
  const ALWAYS = '.mk__summary .mk__atc, .cart__checkout-button';

  const style = document.createElement('style');
  style.textContent = `
.mg-glow { position: relative; isolation: isolate; }
.mg-glow::before { content: ""; position: absolute; z-index: -1; left: 6%; right: 6%; top: 55%; bottom: -12px; border-radius: 999px; pointer-events: none;
  background: linear-gradient(90deg, #F2735F, #EF6C88, #B98AD6, #6CC6CF, #3DB6E0); filter: blur(14px); opacity: .4; transition: opacity .2s; }
.mg-glow:hover::before { opacity: .6; }
.mg-glow--dark::before { opacity: .3; } /* heller Knopf auf dunklem Grund: Farben leuchten dort stärker, daher leiser (Maui 03.11.2026) */
.mg-glow--dark:hover::before { opacity: .45; }
.mg-glow:has(> [disabled], > .is-missing, > .is-busy)::before { display: none; }`;
  document.head.appendChild(style);

  const isDark = (el) => {
    const m = getComputedStyle(el).backgroundColor.match(/\d+(\.\d+)?/g);
    if (!m) return false;
    const [r, g, b, a = 1] = m.map(Number);
    return a > 0.5 && r + g + b < 120; // nur schwarze/dunkle Knöpfe
  };

  const wrap = (el) => {
    if (el.dataset.mgGlow || el.closest('.mg-glow, .msk__glow')) return;
    // Konfigurator- und Kassen-Knopf immer (sind anfangs grau; der Hauch ist im grauen Zustand per CSS aus)
    if (!el.matches(ALWAYS) && !isDark(el) && !el.matches(LIGHT_OK)) return;
    el.dataset.mgGlow = '1';
    const cs = getComputedStyle(el);
    const span = document.createElement('span');
    span.className = 'mg-glow';
    const parentW = el.parentElement ? el.parentElement.clientWidth : 0;
    // Konfigurator-/Kassen-Knopf sind immer volle Breite (Warenkorb kann beim Erfassen noch unsichtbar sein)
    const full = el.matches(ALWAYS) || (parentW && el.offsetWidth >= parentW - 2);
    if (full) el.style.width = '100%'; // vorher zog die Flex-Spalte den Knopf auf volle Breite, im Rahmen nicht mehr
    // Rahmen so breit wie der Knopf, damit der Hauch nur unter dem Knopf liegt
    span.style.display = full || !cs.display.startsWith('inline') ? 'block' : 'inline-block';
    if (!full) span.style.width = 'fit-content';
    // volle Breite als Spalte, damit der Knopf auch bei „width: auto !important“ (Theme-Regel für den Kassen-Knopf) gestreckt wird
    else { span.style.display = 'flex'; span.style.flexDirection = 'column'; }
    if (el.matches(LIGHT_OK)) span.classList.add('mg-glow--dark');
    if (cs.flexGrow !== '0' || cs.flexBasis !== 'auto') span.style.flex = cs.flex;
    if (cs.alignSelf !== 'auto') span.style.alignSelf = cs.alignSelf;
    if (cs.marginTop !== '0px') { span.style.marginTop = cs.marginTop; el.style.marginTop = '0'; }
    el.parentNode.insertBefore(span, el);
    span.appendChild(el);
  };

  const scan = (root = document) => root.querySelectorAll(TARGETS).forEach(wrap);
  let t = 0;
  const later = () => { clearTimeout(t); t = setTimeout(scan, 120); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();
